import React,{useEffect, useState} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from "axios";
import {useNavigate, useParams} from 'react-router-dom'
import toast from 'react-hot-toast';
import { SERVER_API } from '../../fileWithConstants';
const UpdateCategory = () => {
const navigate = useNavigate();
const [name, setName] = useState('');
const [submitting, setSubmitting] = useState(false);
const [categoryid, setCategoryid]=useState('');
const [categoryCheck, setCategoryCheck] = useState('');
const params = useParams();
const getFabricSingleCategoryData = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-single-category/${params.id}`);
      //console.log(data)
      if(data?.success && data?.category.length>0){
        setName(data?.category[0]['name']);        
      }else{
        toast.error('Some thing went wrong while getting category data.')
      }
    } catch (error) {
      console.log(error)
    }
  }

useEffect(()=>{
    getFabricSingleCategoryData();
    setCategoryid(params.id);
},[categoryid])

const handleUpdate = async(e)=>{
    e.preventDefault();
    if(!submitting) {
      try {
        setCategoryCheck('');
        const {data} = await axios.put(`${SERVER_API}/api/v1/fabric/update-fabric-category/${categoryid}`,{name});
        if(data?.success){
          toast.success(data?.message)
          navigate('/dashboard/category-list')
        }else{
          toast.error(data?.message)
          setCategoryCheck('Category Already exist');
        }
      } catch (error) {
        console.log(error)
      } finally {
        setSubmitting(false);
      }
    }
}

const cancelHandle = ()=>{
    navigate('/dashboard/category-list');
  }

  return (
            <Layout title={'Update Category'}>
                <div className='form-container'>
                    <form onSubmit={handleUpdate} className='form-section'>
                        <h4 className='title'>Update Category</h4>
                        <div className='form-box'>
                            <div className="mb-3">
                                <label>Category Name*</label>
                                <input type="text" 
                                className="form-control"
                                value={name}
                                name='name'
                                onChange={(e)=>setName(e.target.value)}
                                required
                                    />
                                <p className='text-danger'>{categoryCheck}</p>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    <button type="submit" className="btn btn-success form-control">Update</button>
                                </div>
                                <div className='col-6'> 
                                    <button type="button" onClick={cancelHandle} className="btn btn-dark form-control">Cancel</button>
                                </div>
                            </div>
                        </div>      
                    </form>
                </div>
            </Layout>
  )
}

export default UpdateCategory
